import { API_BASE_URL_AWARI } from '@/constants/api'
import { MentorshipsModel } from '@/models'
import setAuthorization from '@/utils/helpers/setAuthorization'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const mentorshipsRepository = createApi({
	reducerPath: 'mentorshipsRepository',
	baseQuery: fetchBaseQuery({
		prepareHeaders: setAuthorization,
		baseUrl: API_BASE_URL_AWARI,
	}),
	tagTypes: ['Mentorships'],

	endpoints: (builder) => ({
		list: builder.query<MentorshipsModel.List, void>({
			query: () => ({
				url: `/events/mentorships`,
				method: 'GET',
			}),
			providesTags: ['Mentorships'],
		}),
		listMutation: builder.mutation<MentorshipsModel.List, void>({
			query: () => ({
				url: `/events/mentorships`,
				method: 'GET',
			}),
			invalidatesTags: ['Mentorships'],
		}),
		scheduleMentorship: builder.mutation<void, MentorshipsModel.Create>({
			query: ({ ...body }) => ({
				url: `/mentorships`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['Mentorships'],
		}),
		rescheduleMentorship: builder.mutation<
			void,
			{
				mentorshipId: string
				date: string
			}
		>({
			query: ({ mentorshipId, ...body }) => ({
				url: `/mentorships/${mentorshipId}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['Mentorships'],
		}),
		cancelMentorship: builder.mutation<
			void,
			{
				mentorshipId: string
				typeReason: string
				reason?: string
			}
		>({
			query: ({ mentorshipId, ...body }) => ({
				url: `/mentorships/${mentorshipId}`,
				method: 'DELETE',
				body,
			}),
			invalidatesTags: ['Mentorships'],
		}),
		attendMentorship: builder.mutation<void, { mentorshipId: string }>({
			query: ({ mentorshipId }) => ({
				url: `/mentorships/${mentorshipId}/presence`,
				method: 'POST',
			}),
			invalidatesTags: ['Mentorships'],
		}),
		feedbackMentorship: builder.mutation<
			void,
			{
				mentorshipId: string
				feedback: string | null
				rating: number | null
				reason: string | null | undefined
				reasonOther: string | null | undefined
				happened: boolean
				type: string
			}
		>({
			query: ({ mentorshipId, ...body }) => ({
				url: `/mentorships/${mentorshipId}/feedback`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['Mentorships'],
		}),
	}),
})

export default mentorshipsRepository
